import * as History from 'history';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { bind } from '../Utils/Bind';
import { Modal, ModalHandle } from './Modal';

export interface IAdmin2FAModalProps {
    readonly location: History.Location;
    readonly url: string;
    readonly requires2FA: boolean;
}

@observer
export class Admin2FAModal extends React.Component<IAdmin2FAModalProps> {
    public componentDidMount() {
        this.tryOpen();
    }

    public componentDidUpdate() {
        this.tryOpen();
    }

    public render() {
        return (
            <Modal
                className="modal-sm static-modal"
                title="Requires 2FA"
                modalHandle={this.handle}
                btnClass="w-50"
                footerClass="d-flex justify-content-center"
                footer={this.footer}
                keyboard={false}
                backdrop="static"
            >
                <div className="text-center">This page requires 2 Factor Authentication</div>
            </Modal>
        );
    }

    @computed
    private get footer() {
        const { url } = this.props;
        const isExternal = url.match(/^https?:\/\//);

        if (isExternal) {
            return (
                <a href={url} className="btn btn-primary" onClick={this.onClose}>
                    Enable
                </a>
            );
        } else {
            return (
                <LinkContainer to={url} className="btn btn-primary">
                    <a onClick={this.onClose}>Enable</a>
                </LinkContainer>
            );
        }
    }

    private tryOpen() {
        const { location, url, requires2FA } = this.props;

        if (location.pathname != url && requires2FA) {
            this.handle.open();
        }
    }

    @bind
    private onClose() {
        this.handle.close();
    }

    private handle = new ModalHandle();
}
